exports.responseHandler = async (input, callback) => {

    // MOD ATENDIMENTO
    if (input.metadata.KM_CHAT_CONTEXT.email) {

        var email = input.metadata.KM_CHAT_CONTEXT.email;

        try {
            const resp = await axios.get("https://hook.us1.make.com/aoizn8svj4yhzatlf4dbbushjrvg7kwn?e-mail=" + email);
            const cliente = resp && resp.data

            // DEBUG await axios.get("https://hook.us1.make.com/riubb4xf5o4mlwhiwn9l5it0xekoo4b6?email=" + email);

            if (cliente.ativo == "true") {
                const limit = new Date()
                limit.setHours(limit.getHours() - 4);

                const at = await axios.get("https://hook.us1.make.com/7dxf5wwc92cu9emul2vnluiddvj1ji75?email=" + email + "&date=" + limit.toISOString())
                const atendimento = at.data

                if (atendimento.horario) {

                    let ed = new Date(atendimento.horario)
                    ed.setHours(ed.getHours() - 3);
                    const day = ed.toISOString().slice(0, 10);
                    const now = new Date()
                    now.setHours(now.getHours() - 3);

                    if (now.toISOString().slice(0, 10) == day && ed.getTime() <= now.getTime()) {
                        //twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + 20);
                        callback([{
                            "message": `Olá ${cliente.nome}, irei te transferir para um de nossos especialistas.`,
                        }])
                    } else {
                        let hora = ed.toISOString().slice(11, 16)
                        callback([{ "message": `Olá ${cliente.nome}, você possui um atendimento agendado para ${day.split("-").reverse().join("/")} às ${hora}` },
                        { "message": `Aguarde até o horário de atendimento e acesse o link de atendimento para ser atendido.` }])
                    }

                } else {
                    callback([{ "message": "Você não possui atendimento agendado para hoje." },
                    {
                        "platform": "kommunicate",
                        "metadata": {
                            "contentType": "300",
                            "templateId": "6",
                            "payload": [{
                                "title": "Tirar dúvidas",
                                "message": "Tirar dúvidas",
                                "replyMetadata": {
                                    "KM_TRIGGER_EVENT": "Dúvidas"
                                }
                            }, {
                                "title": "Agendar atendimento",
                                "message": "Agendar atendimento",
                                "replyMetadata": {
                                    "KM_TRIGGER_EVENT": "Agendar atendimento"
                                }
                            }]
                        }
                    }])
                }

            }

            if (cliente.ativo == "") {
                callback([{
                    "message": "Para agendar atendimento é necessário realizar a assinatura de nossos serviços, clicando no botão abaixo:",
                    "metadata": {
                        "contentType": "300",
                        "templateId": "3",
                        "payload": [{
                            "name": "Assinar Suporte Remoto Ilimitado",
                            "type": "link",
                            "url": "https://portal.daumhelp.online/b/eVa6r5cqM1Pw6u44gg?s=pli&prefilled_email=" + email
                        }, {
                            "title": "Tenho mais dúvidas",
                            "message": "Tenho mais dúvidas",
                            "replyMetadata": {
                                "KM_TRIGGER_EVENT": "Dúvidas"
                            }
                        }]
                    }
                }])
            }

            if (cliente.ativo == "false") {
                callback([{
                    "message": `Olá ${cliente.nome} para regularizar sua assinatura acesse:`,
                    "metadata": {
                        "contentType": "300",
                        "templateId": "3",
                        "payload": [{
                            "type": "link",
                            "name": "Portal de pagamentos",
                            "url": "https://portal.daumhelp.online/b/eVa6r5cqM1Pw6u44gg?s=pli&prefilled_email=" + email
                        }]
                    }
                }])
            }

        } catch (error) {
            await axios.get("https://hook.us1.make.com/riubb4xf5o4mlwhiwn9l5it0xekoo4b6?error=" + error.message)
            callback([{ "message": `Olá, sou seu assistente Virtual Dá um Help!` },
            { "message": `Como posso te ajudar?` },
            {
                "platform": "kommunicate",
                "metadata": {
                    "contentType": "300",
                    "templateId": "6",
                    "payload": [{
                        "title": "Tirar dúvidas",
                        "message": "Tirar dúvidas",
                        "replyMetadata": {
                            "KM_TRIGGER_EVENT": "Dúvidas"
                        }
                    }, {
                        "title": "Agendar atendimento",
                        "message": "Agendar atendimento",
                        "replyMetadata": {
                            "KM_TRIGGER_EVENT": "Agendar atendimento"
                        }
                    }]
                }
            }
            ]);
        }
    } else {

        // MOD AGENDAMENTO
        callback([{ "message": `Olá, sou seu assistente Virtual Dá um Help!` }, { "message": `Como posso te ajudar?` },
        {
            "platform": "kommunicate",
            "metadata": {
                "contentType": "300",
                "templateId": "6",
                "payload": [{
                    "title": "Tirar dúvidas",
                    "message": "Tirar dúvidas",
                    "replyMetadata": {
                        "KM_TRIGGER_EVENT": "Dúvidas"
                    }
                }, {
                    "title": "Agendar atendimento",
                    "message": "Agendar atendimento",
                    "replyMetadata": {
                        "KM_TRIGGER_EVENT": "Agendar atendimento"
                    }
                }]
            }
        }
        ])

    }
}